/**
 * DealPriorityBadge - Badge visual para prioridade do Deal
 * Exibe cores diferenciadas por nível de prioridade
 * Versão: 1.0.0
 */
import React from 'react';
import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import { DealPriority } from '@/hooks/useCrmDeals';

// Props do componente
interface DealPriorityBadgeProps {
  priority: DealPriority;
  className?: string;
}

// Configuração visual por prioridade
const priorityConfig: Record<DealPriority, { 
  label: string;
  className: string;
}> = {
  low: {
    label: 'Baixa',
    className: 'bg-slate-100 text-slate-700 hover:bg-slate-100 dark:bg-slate-800 dark:text-slate-300'
  },
  medium: {
    label: 'Média',
    className: 'bg-blue-100 text-blue-700 hover:bg-blue-100 dark:bg-blue-900/50 dark:text-blue-300'
  },
  high: {
    label: 'Alta',
    className: 'bg-orange-100 text-orange-700 hover:bg-orange-100 dark:bg-orange-900/50 dark:text-orange-300'
  },
  urgent: {
    label: 'Urgente',
    className: 'bg-red-100 text-red-700 hover:bg-red-100 dark:bg-red-900/50 dark:text-red-300'
  }
};

/**
 * Badge visual para exibir prioridade do Deal
 */
export function DealPriorityBadge({ 
  priority, 
  className 
}: DealPriorityBadgeProps) {
  const config = priorityConfig[priority];

  return (
    <Badge 
      variant="secondary"
      className={cn(config.className, className)}
    >
      {config.label}
    </Badge>
  );
}
